import { render } from "./System-Tasks.vue?vue&type=template&id=24031970&scoped=true"
import script from "./System-Tasks.vue?vue&type=script&lang=js"
export * from "./System-Tasks.vue?vue&type=script&lang=js"

import "./System-Tasks.vue?vue&type=style&index=0&id=24031970&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24031970"]])

export default __exports__